export enum EProfileTab {
  PERSONAL_DETAILS = 'perosnal-details',
  SMS_NOTIFICATIONS = 'sms-notifications',
  STORE_DETAILS = 'store-details',
  SIGN_IN_SETTINGS = 'sign-in-settings',
  CO_HOSTS = 'co-hosts',
}
